import styled, { css } from "styled-components";
import { colors2, transition } from "oolib";

export const CONTAINER_PADDING = 10;
const barColor = colors2.secondaryContainer; // temp color
const { grey5 } = colors2

export const StyledBarGraphContainer = styled.div`
    padding: ${CONTAINER_PADDING}px;
    padding-bottom: 0.4rem; // UI scroll bar bottom space 
    overflow-x: auto;
    background-color: white;
    border-radius: 8px;
`

export const StyledBarGraphCollectionWrapper = styled.div`
    display: flex;
`

export const StyledBarGraphWrapper = styled.div`
    display: flex;
    position: relative;

  `

const generateDebugLines = (barSections, debug) => {
    if (!debug) return '';
    
    const lines = [];
    for (let i = 1; i <= barSections; i++) {
        lines.push('linear-gradient(to right, #383838 0%, #383838 100%)');
    }
    
    const positions = [];
    for (let i = 0; i <= barSections; i++) {
        const position = (100 / barSections) * i;
        positions.push(`0 ${position}%`);
    }
    
    return `
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: ${lines.join(', ')};
            background-size: ${Array(barSections).fill('100% 1px').join(', ')};
            background-position: ${positions.join(', ')};
            background-repeat: no-repeat;
            pointer-events: none;
            z-index: 0;
        }
    `;
};


export const StyledSingleBarWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-end;
    position: relative;
    cursor: pointer;
    border-radius: 2px;

    &:hover {
       background-color: ${grey5};
    }

    ${({ barSections, debug }) => generateDebugLines(barSections, debug)}
    
    > * {
        position: relative;
        z-index: 1;
    }
    
    ${({ $isOverflowing }) => $isOverflowing && `
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            translate: -50% 0;
            width: 20px;
            height: 30px;
            background: linear-gradient(to top, transparent, ${colors2.white});
            z-index: 2;
        }
        &:hover::after {
            background: linear-gradient(to top, transparent, #f2f2f2);
        }
    `}
`

export const StyledBar = styled.div`
    border-radius: 2px;
    background-color: ${barColor};
    color: ${colors2.onSecondary};
    position: relative;
    ${transition("width")};
    ${transition("height")};
`

export const StyledLabelWrapper = styled.div`
    position: absolute;
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: nowrap;
    display: flex;
    max-width: ${({ $maxWidth }) => $maxWidth ? `${$maxWidth}px` : 'none'};
    overflow: hidden;
    left: 50%;
    translate: -50% 0;
    bottom: 0.8rem;
`

export const StyledCategoryTitle = styled.div`
    background: ${grey5};
    border-radius: 2px;
    padding: 0.3rem 0 0.3rem 0.8rem;
    max-height: 50px;
    overflow: hidden;
`

export const StyledFadingText = styled.span`
    display: inline-block;
    white-space: nowrap;
    max-width: 100%;
    ${({ $isOverflowing }) => $isOverflowing && `
        mask-image: linear-gradient(to right, black calc(100% - 30px), transparent 100%);
        -webkit-mask-image: linear-gradient(to right, black calc(100% - 30px), transparent 100%);
    `}
`

export const YAxisLabels = styled.div`
  height: inherit;
  display: flex;

  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 4px;

  color: ${colors2.grey50};
  z-index: 100;
`;

export const generateYAxisValues = (barDivisions) => {
    // For 5 labels, we want to divide the range into 4 equal parts
    const numLabels = 5;
    const step = barDivisions / (numLabels - 1);
    
    const values = [];
    for (let i = 0; i < numLabels; i++) {
      values.push(Math.round(step * i));
    }
    
    // Ensure the last value is exactly barDivisions to avoid rounding errors
    values[values.length - 1] = barDivisions;
    
    const uniqueValues = [];
    const seen = new Set();
    
    for (const value of values) {
      if (!seen.has(value)) {
        uniqueValues.push(value);
        seen.add(value);
      }
    }
    
    return uniqueValues;
};